<div class="courses-all">
  <div class="courses-all__container">
    <div class="courses-all__column">
      <app-course-list-header [title]="'app.components.studiesAll.title'" [subtitle]="'app.components.studiesAll.subtitle'" [coursesCount]="courses().length" [filterChips]="filterChips" (chipSelected)="onChipSelected($event)"></app-course-list-header>
      
      @if (courses().length > 0) {
        <app-course-list [courses]="courses() || []"></app-course-list>
      } @else {
        <app-empty-course-list [showButton]="false"></app-empty-course-list>
      }
    </div>

    <div class="courses-all__column">
      <div class="section">
        <div class="section__header">
          <h2 class="section__title">{{ 'app.components.studiesAll.progress' | translate }}</h2>
        </div>
        <app-progress-card [completionRate]="completionRate() ?? 0"></app-progress-card>
      </div>
    </div>
  </div>
</div>
